import clsx from "classnames";
import classes from "./styles.module.scss";

export default function DiscoverScroll({ className }) {

  return (
    <div className={clsx(className, classes.scroll)}>
      <span>Scroll to discover</span>
       <img alt="scroll down" src="/icons/scroll_down.png"/>
    </div>
  );
}

DiscoverScroll.defaultProps = {
  className: "",
};
